var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Defaults, Watch, PropertyConverters, ViewChild, Debounce, Utils, CustomElementUtils, RepeaterItem } from '@pacem/pacem-core';
import { Components as ScaffoldingComponents } from '@pacem/pacem-scaffolding';
import { PacemElementPickerElementBase } from './element-picker';
//namespace Pacem.Components.Cms {
export var ExpressionSource;
(function (ExpressionSource) {
    ExpressionSource["Constant"] = "const";
    ExpressionSource["PropertyReference"] = "property";
    ExpressionSource["Expression"] = "expr";
})(ExpressionSource || (ExpressionSource = {}));
let PacemExpressionElement = class PacemExpressionElement extends PacemElementPickerElementBase {
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (name === 'converter') {
            this._setFeedbackText(this.value);
        }
        else if (!first) {
            if (this._editing) {
                switch (name) {
                    case '_source':
                        switch (val) {
                            case ExpressionSource.PropertyReference:
                                this._picker.focus();
                                break;
                            default:
                                this._editor.focus();
                                break;
                        }
                        break;
                    case '_propRef':
                        if (!Utils.isNullOrEmpty(val)) {
                            this._editor.focus();
                            this._editor.value = '{{ #' + this._sourceRef.id + '.' + val + '  }}';
                        }
                        this.changeHandler(new Event('change'));
                        break;
                }
            }
        }
    }
    get inputFields() {
        return [this._editor];
    }
    toggleReadonlyView(readonly) {
        if (readonly) {
            // ensure not editing
            this._editing = false;
        }
    }
    setPristine() {
        super.setPristine();
        this._editing = false;
    }
    onChange(_) {
        return Utils.fromResult(this.value = this._editor.value);
    }
    acceptValue(val) {
        this._view.textContent = val || '...';
        this._setFeedbackText(val);
        this._reverseStructure();
        if (val !== this._editor.value) {
            this._editor.value = val;
        }
    }
    _setFeedbackText(val = this.value) {
        const converter = this.converter;
        if (CustomElementUtils.isBindingAttribute(val) || typeof (converter && converter.convert) !== 'function') {
            this._eval.setAttribute('text', val);
        }
        else if (val === undefined) {
            this._eval.text = '<undefined>';
        }
        else {
            this._eval.text = converter.convert(val);
        }
    }
    getViewValue(value) {
        return value;
    }
    convertValueAttributeToProperty(attr) {
        return attr;
    }
    _reverseStructure() {
        let cleanup = () => {
            this._source = this._sourceRef = this._propRef = /*this.value =*/ undefined;
        };
        // dependencies?
        let expr = this.value;
        if (!Utils.isNullOrEmpty(expr)) {
            // setup the most likely form fields
            if (CustomElementUtils.isBindingAttribute(expr)) {
                const expression = CustomElementUtils.parseBindingAttribute(expr, this), deps = expression.dependencies;
                // complex or simple (one dependency) expression
                if (Utils.isNullOrEmpty(deps) || deps.length > 1 || RepeaterItem.isRepeaterItem(deps[0].element)) {
                    this._source = ExpressionSource.Expression;
                }
                else {
                    const dep = deps[0];
                    this._source = ExpressionSource.PropertyReference;
                    this._sourceRef = document.querySelector('#' + dep.element.id);
                    this._propRef = dep.path;
                }
            }
            else {
                this._source = ExpressionSource.Constant;
            }
            //
        }
        else {
            cleanup();
        }
    }
};
__decorate([
    Watch({ emit: false })
], PacemExpressionElement.prototype, "converter", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Boolean })
], PacemExpressionElement.prototype, "_editing", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemExpressionElement.prototype, "_source", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Element })
], PacemExpressionElement.prototype, "_sourceRef", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemExpressionElement.prototype, "_propRef", void 0);
__decorate([
    ViewChild(P + '-element-picker')
], PacemExpressionElement.prototype, "_picker", void 0);
__decorate([
    ViewChild(P + '-textarea')
], PacemExpressionElement.prototype, "_editor", void 0);
__decorate([
    ViewChild('span.' + PCSS + '-viewfinder')
], PacemExpressionElement.prototype, "_view", void 0);
__decorate([
    ViewChild(P + '-text')
], PacemExpressionElement.prototype, "_eval", void 0);
__decorate([
    Debounce(50)
], PacemExpressionElement.prototype, "_reverseStructure", null);
PacemExpressionElement = __decorate([
    CustomElement({
        tagName: P + '-expression', shadow: Defaults.USE_SHADOW_ROOT,
        template: `<${P}-collapse class="${PCSS}-expression" collapse="{{ !:host._editing }}">
    <div class="expression-builder ${PCSS}-grid grid-tiny-rowgap grid-tiny-colgap ${PCSS}-pad pad-bottom-2">
        <div class="${PCSS}-cell">
            <${P}-select value="{{ :host._source, twoway }}" class="display-block">
                <${P}-data-item value="${ExpressionSource.Constant}" label="constant value"></${P}-data-item>
                <${P}-data-item value="${ExpressionSource.PropertyReference}" label="property reference"></${P}-data-item>
                <${P}-data-item value="${ExpressionSource.Expression}" label="complex expression"></${P}-data-item>
            </${P}-select>
        </div>

        <${P}-panel class="${PCSS}-cell cols-hd-6" hide="{{ :host._source !== '${ExpressionSource.PropertyReference}' }}">
            <${P}-element-picker value="{{ :host._sourceRef, twoway }}" selector="{{ :host.selector }}" filter="{{ :host.filter }}" labeler="{{ :host.labeler }}" class="display-block"></${P}-element-picker>
        </${P}-panel>
        <${P}-panel class="${PCSS}-cell cols-hd-6" hide="{{ :host._source !== '${ExpressionSource.PropertyReference}' }}">
            <${P}-property-picker value="{{ :host._propRef, twoway }}" disabled="{{ !:host._sourceRef }}" target="{{ :host._sourceRef }}" on-change="::_editor.focus()" class="display-block"></${P}-property-picker>
        </${P}-panel>

        <${P}-panel class="${PCSS}-cell">
            <${P}-textarea class="display-block" placeholder="{{ '{{ '+ (:host._source || '') +'... }}' }}" change-policy="${ScaffoldingComponents.Scaffolding.ChangePolicy.Blur}"></${P}-textarea>
        </${P}-panel>
    </div>
</${P}-collapse>
<div class="${PCSS}-fieldset">
    <div class="fieldset-left">
        <div class="${PCSS}-fieldgroup ${PCSS}-viewfinder">
            <div class="text-truncate ${PCSS}-pad pad-x-1"><span class="${PCSS}-viewfinder text-tech">{{ :host.value || '...' }}</span></div>
            <${P}-panel class="fieldgroup-prepend">
                <${P}-button class="flat edit ${PCSS}-pad pad-left-1" on-click=":host._editing = !:host._editing" hide="{{ :host.readonly }}"></${P}-button>
            </${P}-panel>
            <${P}-panel class="fieldgroup-append text-tech display-flex flex-middle flex-nowrap" hide="{{ $pacem.isNullOrEmpty(:host.value) }}">
                <i class="${PCSS}-icon text-primary">keyboard_arrow_right</i>
                <${P}-text text="?" class="bg-primary ${PCSS}-pad pad-left-1 pad-right-1 ${PCSS}-margin margin-right-1 text-truncate" eval></${P}-text>
            </${P}-panel>
        </div>
    </div>
</div>`
    })
], PacemExpressionElement);
export { PacemExpressionElement };
